/**
 * @preserve  shrinkify
 * @name      jquery.shrinkify.js
 * @author    Chuck Skoda
 * @version   0.1.0
 * @date      2013-09-12
 * @copyright (c) 2013 Tagboard
 * @license   MIT License
 * @homepage  https://github.com/jquery-textfill/jquery-textfill
 * @example   http://jquery-textfill.github.io/jquery-textfill/index.html
*/
; (function($) {
	/**
	* Resizes an inner element's font so that the font-size shrinks to prevent overflow
	* @param {Object} Options which are minFontPct (default=50)
	* @return All outer elements processed
	*/
	$.fn.shrinkify = function(options) {
		var defaults = {
				minFontPct: 50,
				width: true,
				height: true },
  			opts = $.extend(defaults, options),
  			$this = $(this);

		if (overflowing($this[0], opts)){
			// We're overflowing, calculate font height
			var min = opts.minFontPct,
  				max = 100,
  				lastOverflow;

			// Do a binary search to find the biggest font size that doesn't overflow.
			while ((max - min) > 1) {
				var mid = Math.floor((min + max) / 2);
				$this.css('font-size', mid + '%');

				if (overflowing($this[0], opts)) {
					max = mid;
					lastOverflow = true;
				} else {
					min = mid;
					lastOverflow = false;
				}
			}

			if (lastOverflow) {
				$this.css('font-size', min + '%');
			}
		}
	};

	function overflowing(oElm, options){
		if ((options.height && (options.maxHeightPx || oElm.offsetHeight) < oElm.scrollHeight) ||
			(options.width && (options.maxWidthPx || oElm.offsetWidth) < oElm.scrollWidth)){
			return true;
		}
		return false;
	}
})(window.jQuery);
